import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  standalone: false,name: 'emptyDash'})

export class EmptyDashPipe implements PipeTransform {
  transform(value: any): string {
    if (value === null || value === undefined || value === '' || value?.length === 0) {
      return '—';
    }
    return value;
  }
}
